import type React from 'react';

import { observer } from 'mobx-react';

import ClickFieldRequired from '../required';
import ClickFieldReset from '../reset';
import type { IProps as IClickFieldResetProps } from '../reset';

export interface IProps
  extends Omit<React.LabelHTMLAttributes<HTMLLabelElement>, 'onReset'>,
    Partial<IClickFieldResetProps> {
  label?: React.ReactNode;
  required?: boolean;
  resetable?: boolean;
}

const ClickFieldLabel: React.FC<IProps> = observer(
  ({ className, label, name, required, resetable, onReset, ...props }) => {
    return (
      <label {...props} className={`click-label ${className ?? ''}`}>
        <span>
          {label}
          {required && <ClickFieldRequired />}
        </span>
        {resetable && <ClickFieldReset name={name!} onReset={onReset} />}
      </label>
    );
  }
);

ClickFieldLabel.displayName = 'ClickFieldLabel';

export default ClickFieldLabel;
